import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=3ec9fa20&scoped=true&"
import script from "./CheckForm.vue?vue&type=script&lang=ts&"
export * from "./CheckForm.vue?vue&type=script&lang=ts&"
import style0 from "./CheckForm.vue?vue&type=style&index=0&id=3ec9fa20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9fa20",
  null
  
)

export default component.exports